import { useLink } from '../state';

const Link = () => {
  const link = useLink();
  console.log('Link:', link);

  return (
    <div className={'account-widget flex-1 min-w-0 max-w-full w-full items-center flex'}>
      <a className="break-all" href={link} target="_blank" rel="noopener noreferrer">
        {link}
      </a>
    </div>
  );
};

export default Link;
